export abstract class AlertBarNotifierBase {
    showError: (panelName: string, errorMessage: string) => void = (panelName: string, errorMessage: string) => { };
    hideError: () => void = () => { };
    showWarning: (warningMessage: string) => void = (warningMessage: string) => { };
    hideWarning: () => void = () => { };
    showInformation: (panelName: string, informationMessage: string) => void = (panelName: string, informationMessage: string) => { };
    hideInformation: () => void = () => { };
    showSuccess: (successMessage: string) => void = (successMessage: string) => { };
    hideSuccess: () => void = () => { };
}